import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const ActionWrapper = styled.div`
  display: flex;
`;

export const Metas = styled.div`
  display: flex;
  flex-direction: column;

  h1 {

    font-size: 24px;
    font-weight: 400;
    line-height: 29px;
    text-align: left;
    margin-top: 20px;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    text-align: left;
  }

  .breadcrumb {
    display: flex:
    gap: 10px;
    margin-top: 22px;

    span{
        cursor: pointer;

        &.active{
          color: ${({ theme }) => theme.colors.tab.main};
        }
    }
  }
`;

export const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const FolderList = styled.ul`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  list-style: none;
  margin: 20px 0 0 0;
  padding: 0;
`;

export const FolderItem = styled.li`
  margin: 0;
  padding: 0;
  width: 23.8%;
`;

export const FolderSelf = styled.button`
  width: 100%;
  height: 245px;
  border-radius: 7px;
  padding: 20px;
  border: none;
  background-color: ${({ theme }) => theme.colors.common.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  transition: 0.4s ease-in-out all;

  svg {
    path {
      transition: 0.4s ease-in-out all;
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent.hover};

    svg {
      & path {
        fill: ${({ theme }) => theme.colors.background.action}!important;
      }
    }

    h3,
    p {
      color: ${({ theme }) => theme.colors.background.action};
    }
  }

  .meta {
    text-align: left;

    h3 {
      font-size: ${({ theme }) => theme.fonts.title['font-size']};
      line-height: ${({ theme }) => theme.fonts.title['line-height']};
      font-weight: 600;
      transition: 0.4s ease-in-out all;
    }

    p {
      font-size: ${({ theme }) => theme.fonts.label['font-size']};
      line-height: ${({ theme }) => theme.fonts.label['line-height']};
      font-weight: 300;
      margin-top: 12px;
      transition: 0.4s ease-in-out all;
    }
  }
`;

export const STable = styled.table`
  margin-top: 20px;

  tr {
    border-top: 1px solid black;
    position: relative;
    cursor: pointer;
    transition: 0.4s ease-in-out all;

    &:hover {
      background-color: ${({ theme }) => theme.colors.common.white};
    }

    &::after {
      content: '';
      width: 99%;
      position: absolute;
      height: 1px;
      left: 0.5%;
      top: 100%;
      background: ${({ theme }) => theme.colors.border.default};
    }
  }

  td {
    padding: 15px 0;
    border: none;
    outline: none;

    &:first-child {
      border-top-left-radius: 7px;
      border-bottom-left-radius: 7px;
      padding-left: 10px;
    }

    &:last-child {
      border-top-right-radius: 7px;
      border-bottom-right-radius: 7px;
      padding-right: 10px;
    }
  }
`;

export const RightAlignedCell = styled.td`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const SpacedText = styled.span`
  margin-left: 10px;
`;
